export default __webpack_public_path__ + "static/media/sopha_sider.dfd7cdf5.png";